export class CoachingGuideQuestion {
    factor: string;
    coachingQuestions: string[];
}
